namespace app.notification {
    "use strict";
	
    /** @ngInject */
    function run($rootScope: ng.IRootScopeService, notificationService: NotificationService) {
        
        notificationService.init();
        
        $rootScope.$on("user:logged", () => {
            notificationService.init();
        });
        
        $rootScope.$on("user:exited", () => {
            notificationService.stop(); 
        });
    }

    angular
        .module("app.notification", ["app.support", "app.autenticacao"])
        .run(run);
}
